// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"288":"3e252b20","827":"aaf6af09"}[chunkId] + ".css";
};